<template>
  <div>
    <!-- To be implemented -->
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/scss/utilities";

div {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;

  @include font-bold(32);
}
</style>
